module.exports = __webpack_public_path__ + "img/侧边背景@3x.09e45018.png";